import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Paginator } from 'primereact/paginator'
import ExcelExportButton from '../../components/ui/ExcelExportButton'
import PageHeader from '../../components/ui/PageHeader'
import MeetingList from './components/MeetingList'
import { exportArchivedMeetings } from './api/meetingApi'
import { useArchivedMeetings } from './hooks/useArchivedMeetings'
import { useNavigateWithOrigin } from '../../app/nav/originNav'
import './meetings.css'

const PAGE_SIZE = 20

/**
 * Arşivlenen Toplantılar (044) — <b>salt-okuma</b> liste. 30 günü geçip arşivlenen (MEETING_STATUS_ID=362)
 * tutanaklar tüm gruplardan listelenir; satır → Toplantı Detay (arşivli olduğundan Düzenle gizli, güncellenemez).
 * Arşivden geri alma yoktur. (Otomatik arşivleme job'ı bu fazda yok; durum DB'de/ileride job ile set edilir.)
 */
export default function MinutesArchivedMeetingsPage() {
  const { t } = useTranslation()
  // Detaya giderken Arşivlenen Toplantılar listesi origin taşınır → Toplantı Detay'da "Geri" buraya döner.
  const navigate = useNavigateWithOrigin()
  const [page, setPage] = useState(0)
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | -1 | 0 | null | undefined>(undefined)
  const sort = sortField ? `${sortField},${sortOrder === 1 ? 'asc' : 'desc'}` : undefined

  const archived = useArchivedMeetings(page, PAGE_SIZE, sort)
  const total = archived.data?.page.totalElements ?? 0

  return (
    <div className="page minutes-page">
      <PageHeader
        title={t('meetings.archived.title')}
        actions={
          <ExcelExportButton
            onExport={() => exportArchivedMeetings(sort)}
            disabled={(archived.data?.content ?? []).length === 0}
          />
        }
      />
      <MeetingList
        items={archived.data?.content ?? []}
        loading={archived.isLoading}
        totalRecords={total}
        onSelect={(id) => navigate(`/minutes/archived/meetings/${id}`)}
        showGroup
        sortField={sortField}
        sortOrder={sortOrder}
        onSort={(e) => {
          setSortField(e.sortField)
          setSortOrder(e.sortOrder)
          setPage(0)
        }}
      />
      {total > PAGE_SIZE && (
        <Paginator
          first={page * PAGE_SIZE}
          rows={PAGE_SIZE}
          totalRecords={total}
          onPageChange={(e) => setPage(e.page)}
        />
      )}
    </div>
  )
}
